<template>
    <div class="relative">
        <algolia-get
            v-slot="{
                data,
                meta,
                clear,
                filterByQuery,
                get,
            }"
            index="dashboard"
            :get-on-created="false"
        >
            <with-variables
                v-slot="{
                    search
                }"
                :variables="{
                    search: (query) => {
                        clear(),
                        filterByQuery(query)
                        get()
                    }
                }"
            >
                <base-dropdown
                    placement="bottom"
                    :fill="true"
                >
                    <template
                        v-slot:trigger="{
                            isOpen,
                            open,
                            close
                        }"
                    >
                        <input
                            ref="input"
                            v-model="query"
                            class="bg-blue-bg-dark focus:outline-none focus:shadow-outline inline-block w-full
                                rounded pl-12 pr-3 py-2"
                            type="text"
                            placeholder="Search..."
                            @input="search(query)"
                            @focus="open(); search(query)"
                            @keydown.escape.prevent="arguments[0].target.blur()"
                            @keydown.down.prevent="highlightNext(data)"
                            @keydown.up.prevent="highlightPrev(data)"
                            @keydown.enter.prevent="isOpen ? selectHighlighted(data, close) : null"
                            @keydown.tab.prevent
                        >
                    </template>

                    <template v-slot:menu>
                        <div
                            v-if="data.length"
                            class="dropdown-menu w-full mt-3px py-2"
                        >
                            <div class="-mt-4">
                                <div
                                    v-for="(result, i) in compose(data)"
                                    :key="i"
                                    class="mt-4"
                                >
                                    <div class="dropdown-menu-label">
                                        {{ result.label }}
                                    </div>

                                    <router-link
                                        v-for="item in result.results"
                                        :key="item.index"
                                        :to="item.to"
                                        :class="{
                                            'is-active': item.index === highlighted_index
                                        }"
                                        class="dropdown-menu-link overflow-x-hidden truncate"
                                    >
                                        {{ item.title }}

                                        <div
                                            v-if="item.subtitle"
                                            class="text-xs text-grey-light overflow-x-hidden truncate"
                                        >
                                            {{ item.subtitle }}
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </template>
                </base-dropdown>
            </with-variables>
        </algolia-get>

        <div class="absolute left-0 inset-y-0 flex items-center pl-3 pointer-events-none">
            <base-svg
                name="icon-search"
                key="icon-search"
                class="w-6 h-6 fill-primary-grey-dark fill-secondary-transparent"
            />
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import AlgoliaGet from '../components/algolia-get'

    export default {
        components: {
            AlgoliaGet
        },
        data () {
            return {
                query: '',
                highlighted_index: -1
            }
        },
        methods: {
            compose (data) {
                const results = {
                    property: {
                        label: 'Properties',
                        results: []
                    },
                    tenancy: {
                        label: 'Tenancies',
                        results: []
                    }
                }

                _.each(data, result => {
                    if (_.has(results, result.object)) {
                        const prepared = this.prepare(result)

                        if (prepared) {
                            results[result.object].results.push(prepared)
                        }
                    }
                })

                let index = 0

                _.each(results, item => {
                    _.each(item.results, result => {
                        result.index = index++
                    })
                })

                return _.filter(results, item => {
                    return !_.isEmpty(item.results)
                })
            },
            prepare (result) {
                if (!_.isFunction(this[result.object])) {
                    return null
                }

                return this[result.object](result)
            },
            property (result) {
                return {
                    title: result.name,
                    to: {
                        name: this.$router.fix('dashboard.*.properties.show'),
                        params: {
                            property: result.uuid
                        }
                    }
                }
            },
            tenancy (result) {
                return {
                    title: result.property.name,
                    subtitle: result.tenants.length
                        ? _.map(result.tenants, 'name').join(', ')
                        : 'No tenants',
                    to: {
                        name: this.$router.fix('dashboard.*.tenancies.show'),
                        params: {
                            tenancy: result.uuid
                        }
                    }
                }
            },
            select (result, close) {
                this.$router.push(this.prepare(result).to)

                close()

                this.highlight(0)

                this.highlighted_index = -1

                this.$refs.input.blur()
            },
            selectHighlighted (results, close) {
                this.select(results[this.highlighted_index], close)
            },
            highlightNext (results) {
                this.highlight(results, this.highlighted_index + 1)
            },
            highlightPrev (results) {
                this.highlight(results, this.highlighted_index - 1)
            },
            highlight (results, index) {
                this.highlighted_index = index

                if (this.highlighted_index < 0) {
                    this.highlighted_index = results.length - 1
                }

                if (this.highlighted_index > results.length - 1) {
                    this.highlighted_index = 0
                }
            }
        }
    }
</script>
